import { useParams } from 'react-router-dom';
import { Button, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';

import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { headTbl } from '../../../data/tables';
import LoadinSpin from '../../ui/LoadinSpin';
import { useGetDta } from '../../../hooks/useGetDta';
import Table from '../../Table';
import ModBono from './ModBono';
import ChangeConfirmation from '../../ui/ChangeConfirmation';
import { checkAccess } from '../../../helpers/details';
import { AuthContext } from '../../../auth/AuthContext';

const BonosUs = ({ activo, activeTab }) => {
    const { id } = useParams();
    const { auth } = useContext(AuthContext);

     const permisos = checkAccess('Facturación', auth.accesos);
        const {
           
            fact_agregar_bono,
            fact_eliminar_bono} = permisos.functions

    let idR = atob(id);
    const [show, setShow] = useState(false);
    const [showd, setShowd] = useState(false);
    const [info, setInfo] = useState({});

    const { loading, data, getInfo } = useGetDta(`usertools/bonus/${idR}`);

    useEffect(() => {
        getInfo(`usertools/bonus/${idR}`);
    }, [activeTab, activo, idR]);

    const ActionColumn = ({ row }) => {
        const item = { id: row.original.id, nota: row.original.nota };
        return (
            <>
               
                    {fact_eliminar_bono && (
                        <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-example">Borrar</Tooltip>}>
                            <i className="mdi mdi-delete mdi-18px mx-2 " onClick={() => dele(item)}></i>
                        </OverlayTrigger>
                    )}
               
            </>
        );
    };
    const dele = ({ id, nota }) => {
        setInfo({
            data: { id },
            endpoint: `usertools/bono`,
            head: 'Eliminar Bonificación',
            body: `La bonificación con el concepto ${nota} sera Eliminado actulizando la fecha de corte de acuerdo a los meses registrados en la bonificación`,
        });
        setShowd(true);
    };

    const TipoColumn = ({ row }) => {
        return <>{moment(row.original.createdAt).format('YYYY-MM-DD HH:mm:ss')}</>;
    };
    const columns = [
        {
            Header: 'Fecha',
            accessor: 'createdAt',
            sort: true,
            Cell: TipoColumn,
        },
        {
            Header: 'Meses',
            accessor: 'meses',
            sort: true,
        },
        {
            Header: 'Fecha corte',
            accessor: 'fecha',
            sort: true,
        },
        {
            Header: 'Nota',
            accessor: 'nota',
            sort: true,
        },
        {
            Header: 'Agente',
            accessor: 'agente',
            sort: true,
        },

        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(data.length);
    if (loading) return <LoadinSpin />;
    return (
        <div className="mt-3">
            {fact_agregar_bono && (
                <Row className="mb-2">
                    <Col xs="auto">
                        <Button type="button" onClick={() => setShow(true)}>
                            <b>+</b> Nuevo
                        </Button>
                    </Col>
                </Row>
            )}
            <Table
                columns={columns}
                data={data}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                isSearchable={true}
                searchBoxClass="mb-2"
            />
            <ModBono show={show} onClose={() => setShow(!show)} callBk={getInfo} id={idR} />
            <ChangeConfirmation
                show={showd}
                onClose={() => setShowd(false)}
                info={info}
                callBk={getInfo}
                method="DELETE"
            />
           
        </div>
    );
};
export default BonosUs;
